
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 27 27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#78909C","d":"M13.64.563h-.843v5.062h.844z"}}),_c('path',{attrs:{"fill":"#78909C","d":"M15.75 2.672h-5.062v.844h5.062z"}}),_c('path',{attrs:{"fill":"#5C6BC0","d":"M23.766 10.688h-.844v5.062h.844z"}}),_c('path',{attrs:{"fill":"#5C6BC0","d":"M25.875 12.797h-5.062v.844h5.062z"}}),_c('path',{attrs:{"fill":"#78909C","d":"M3.516 10.688h-.844v5.062h.844z"}}),_c('path',{attrs:{"fill":"#78909C","d":"M5.625 12.797H.563v.844h5.062z"}}),_c('path',{attrs:{"fill":"#5C6BC0","d":"M13.64 20.813h-.843v5.062h.844z"}}),_c('path',{attrs:{"fill":"#5C6BC0","d":"M15.75 22.922h-5.062v.844h5.062z"}}),_c('path',{attrs:{"fill":"#E8762D","d":"M18 12.375H8.438v1.688H18z"}}),_c('path',{attrs:{"fill":"#E8762D","d":"M14.063 8.438h-1.688V18h1.688z"}}),_c('path',{attrs:{"fill":"#FFA000","d":"M7.313 3.375H6.188v7.875h1.125z"}}),_c('path',{attrs:{"fill":"#FFA000","d":"M10.688 6.75H2.811v1.125h7.876z"}}),_c('path',{attrs:{"fill":"#607D8B","d":"M20.25 3.375h-1.125v7.875h1.125z"}}),_c('path',{attrs:{"fill":"#607D8B","d":"M23.625 6.75H15.75v1.125h7.875z"}}),_c('path',{attrs:{"fill":"#C62828","d":"M7.313 15.188H6.188v7.874h1.125z"}}),_c('path',{attrs:{"fill":"#C62828","d":"M10.688 18.563H2.811v1.125h7.876z"}}),_c('path',{attrs:{"fill":"#0D47A1","d":"M20.25 15.188h-1.125v7.874h1.125z"}}),_c('path',{attrs:{"fill":"#0D47A1","d":"M23.625 18.563H15.75v1.125h7.875z"}})])
          )
        }
      }
    